import React from "react";
import { Link } from "react-router-dom";
import {
  ArrowLeft,
  Download,
  Smartphone,
  Tv,
  Monitor,
  MessageCircle,
  Tv2,
  CheckCircle2,
  ShieldCheck,
  Zap,
  XCircle,
  Apple,
  Radio,
  Laptop,
  ExternalLink,
} from "lucide-react";
import { downloadApps } from "../data/apps";

const WA_LINK = `https://wa.me/5588988676142?text=${encodeURIComponent("Olá! Preciso de ajuda para instalar o app do UniPlay UHD.")}`;

function formatDownloads(n) {
  return n.toLocaleString("pt-BR");
}

export default function Downloads() {
  const app = downloadApps[0];

  return (
    <div className="min-h-screen bg-[#0a0a0c] text-white">
      {/* Header */}
      <header className="sticky top-0 z-40 backdrop-blur-md bg-[#0a0a0c]/80 border-b border-white/5">
        <div className="max-w-[1500px] mx-auto px-6 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 group">
            <ArrowLeft className="w-4 h-4 text-white/60 group-hover:text-white transition" />
            <img
              src="https://customer-assets.emergentagent.com/job_hardcore-lichterman-3/artifacts/zntek32k_images.png"
              alt="UniPlay UHD"
              className="w-11 h-11 rounded-xl object-cover"
            />
            <span className="hidden sm:block text-xl font-extrabold text-white tracking-tight">
              UNIPLAY <span className="text-[10px] font-bold text-cyan-400 align-top">UHD</span>
            </span>
          </Link>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#25D366] hover:brightness-110 text-white text-sm font-semibold transition"
          >
            <MessageCircle className="w-4 h-4" /> <span className="hidden sm:inline">Suporte</span>
          </a>
        </div>
      </header>

      {/* Hero */}
      <section className="relative overflow-hidden">
        <div
          className="absolute inset-0 -z-10"
          style={{
            backgroundImage:
              "linear-gradient(180deg, rgba(10,10,12,0.6) 0%, rgba(10,10,12,0.98) 90%), url(https://images.unsplash.com/photo-1574375927938-d5a98e8ffe85?w=1600)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "blur(8px)",
            transform: "scale(1.05)",
          }}
        />
        <div className="max-w-[1500px] mx-auto px-6 py-12 md:py-16 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-white/5 border border-white/10 mb-5">
            <Download className="w-10 h-10 text-cyan-400" />
          </div>
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight">
            Baixe o <span className="text-cyan-400">UniPlay UHD</span>
          </h1>
          <p className="mt-3 text-white/65 max-w-2xl mx-auto">
            Aplicativo oficial para Android. Após o download, basta instalar e fazer login com o usuário e senha enviados via WhatsApp.
          </p>
        </div>
      </section>

      {/* Featured app card */}
      <section className="max-w-[1100px] mx-auto px-6 pb-12">
        <div className="rounded-3xl border border-cyan-500/30 bg-gradient-to-br from-[#0a1a2f] via-[#0d0d15] to-[#0a0a0c] overflow-hidden shadow-2xl shadow-cyan-500/10">
          <div className="bg-gradient-to-r from-cyan-500 to-blue-500 text-white text-xs font-bold uppercase tracking-widest py-2 px-4 flex items-center justify-center gap-2">
            <ShieldCheck className="w-3.5 h-3.5" /> Aplicativo Oficial UniPlay UHD
          </div>

          <div className="grid md:grid-cols-[280px_1fr] gap-8 p-6 md:p-10 items-center">
            <div className="flex justify-center">
              <div className="relative">
                <div className="absolute inset-0 bg-cyan-500/30 rounded-3xl blur-2xl" />
                <img
                  src={app.icon}
                  alt={app.name}
                  className="relative w-44 h-44 md:w-56 md:h-56 rounded-3xl object-cover shadow-2xl"
                />
              </div>
            </div>

            <div>
              <h2 className="text-3xl md:text-4xl font-extrabold">{app.name}</h2>
              <p className="text-white/70 mt-3">{app.description}</p>

              <div className="mt-5 grid grid-cols-2 sm:grid-cols-4 gap-2">
                <span className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-white/5 border border-white/10 text-xs text-white/80 font-semibold">
                  <Smartphone className="w-3.5 h-3.5 text-cyan-400" /> Android
                </span>
                <span className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-white/5 border border-white/10 text-xs text-white/80 font-semibold">
                  <Tv className="w-3.5 h-3.5 text-cyan-400" /> Android TV
                </span>
                <span className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-white/5 border border-white/10 text-xs text-white/80 font-semibold">
                  <Monitor className="w-3.5 h-3.5 text-cyan-400" /> TV Box
                </span>
                <span className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-white/5 border border-white/10 text-xs text-white/80 font-semibold">
                  <Tv2 className="w-3.5 h-3.5 text-cyan-400" /> Fire TV
                </span>
              </div>

              <a
                href={app.downloadUrl}
                download
                className="mt-6 inline-flex w-full sm:w-auto items-center justify-center gap-2 px-8 py-4 rounded-2xl bg-gradient-to-r from-cyan-500 to-blue-500 hover:brightness-110 text-white font-bold text-lg shadow-2xl shadow-cyan-500/40 transition"
              >
                <Download className="w-5 h-5" /> BAIXAR APK
              </a>

              <div className="mt-3 flex flex-wrap gap-3 items-center text-xs">
                <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-amber-400/15 border border-amber-400/30 text-amber-300 font-bold uppercase tracking-wider">
                  Downloads: {formatDownloads(app.downloads)}
                </div>
                <div className="inline-flex items-center gap-1.5 text-emerald-400 font-semibold">
                  <CheckCircle2 className="w-3.5 h-3.5" /> Versão oficial mais recente
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Compatibility */}
      <section className="max-w-[1100px] mx-auto px-6 pb-12">
        <h3 className="text-2xl font-bold text-center mb-6">Compatibilidade do APK</h3>
        <div className="grid md:grid-cols-2 gap-4">
          <div className="rounded-2xl border border-emerald-500/30 bg-emerald-500/5 p-5">
            <div className="flex items-center gap-2 text-emerald-400 font-bold mb-3">
              <CheckCircle2 className="w-5 h-5" /> Funciona em
            </div>
            <ul className="space-y-2 text-sm text-white/85">
              <li className="flex items-center gap-2"><Smartphone className="w-4 h-4 text-emerald-400" /> Celulares e tablets Android (5.0 ou superior)</li>
              <li className="flex items-center gap-2"><Tv className="w-4 h-4 text-emerald-400" /> Android TV (Mi Box, Nvidia Shield, Chromecast)</li>
              <li className="flex items-center gap-2"><Monitor className="w-4 h-4 text-emerald-400" /> TV Box (com sistema Android)</li>
              <li className="flex items-center gap-2"><Tv2 className="w-4 h-4 text-emerald-400" /> Amazon Fire TV (com sideload)</li>
            </ul>
          </div>

          <div className="rounded-2xl border border-red-500/30 bg-red-500/5 p-5">
            <div className="flex items-center gap-2 text-red-400 font-bold mb-3">
              <XCircle className="w-5 h-5" /> NÃO funciona em
            </div>
            <ul className="space-y-2 text-sm text-white/85">
              <li className="flex items-center gap-2"><Apple className="w-4 h-4 text-red-400" /> iPhone e iPad (iOS) — fale com o suporte</li>
              <li className="flex items-center gap-2"><Tv2 className="w-4 h-4 text-red-400" /> Smart TV LG (webOS) — usa app pela loja</li>
              <li className="flex items-center gap-2"><Tv2 className="w-4 h-4 text-red-400" /> Smart TV Samsung (Tizen) — usa app pela loja</li>
              <li className="flex items-center gap-2"><Radio className="w-4 h-4 text-red-400" /> Roku — usa canal pela loja Roku</li>
            </ul>
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 text-sm text-[#25D366] hover:underline font-semibold"
            >
              <MessageCircle className="w-4 h-4" /> Tem outro aparelho? Fale com o suporte
            </a>
          </div>
        </div>
      </section>

      {/* How to install */}
      <section className="max-w-[1100px] mx-auto px-6 pb-12">
        <h3 className="text-2xl font-bold text-center mb-6">Como Instalar</h3>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {[
            { n: 1, title: "Permitir Fontes Desconhecidas", desc: "Vá em Configurações > Segurança > Ative 'Fontes Desconhecidas'." },
            { n: 2, title: "Baixar o APK", desc: "Clique no botão BAIXAR APK no topo desta página." },
            { n: 3, title: "Instalar", desc: "Abra o arquivo .apk baixado e toque em INSTALAR." },
            { n: 4, title: "Fazer Login", desc: "Abra o app e use o usuário/senha enviados pelo WhatsApp." },
          ].map((s) => (
            <div key={s.n} className="rounded-2xl bg-white/5 border border-white/10 p-5">
              <div className="w-9 h-9 rounded-full bg-cyan-500 text-white flex items-center justify-center font-extrabold mb-3">
                {s.n}
              </div>
              <p className="font-bold">{s.title}</p>
              <p className="text-xs text-white/60 mt-1">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Help block */}
      <section className="max-w-[1100px] mx-auto px-6 pb-20">
        <div className="rounded-2xl border border-[#25D366]/30 bg-gradient-to-br from-[#16210f] to-[#0d160a] p-6 md:p-8 flex flex-col md:flex-row items-center gap-6">
          <div className="w-16 h-16 rounded-2xl bg-[#25D366]/15 flex items-center justify-center border border-[#25D366]/30">
            <Zap className="w-8 h-8 text-[#25D366]" />
          </div>
          <div className="flex-1 text-center md:text-left">
            <h3 className="text-xl font-bold">Precisa de ajuda na instalação?</h3>
            <p className="text-white/70 text-sm mt-1">
              Nossa equipe te orienta passo a passo pelo WhatsApp para deixar tudo funcionando em poucos minutos.
            </p>
          </div>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#25D366] hover:brightness-110 text-white font-bold shadow-lg shadow-[#25D366]/30 transition"
          >
            <MessageCircle className="w-4 h-4" /> Falar no WhatsApp
          </a>
        </div>
      </section>

      <footer className="text-center py-6 text-xs text-white/40 border-t border-white/5 space-y-1">
        <p>UniPlay UHD © 2024 • Todos os direitos reservados</p>
        <p className="text-white/50">
          <span className="font-semibold text-white/70">Ciapay Sistem LTDA</span> • CNPJ 64.199.817/0001-13
        </p>
      </footer>
    </div>
  );
}
